export default($el) => ({
   el: $el,
  inner: $el.querySelector('.image-scroller__inner'),
  init() {
    console.log('imageScroller init');
    this.addAnimation();
    this.duplicateContent();
  },
  duplicateContent() {
    // @DEV: we may need to calculate this at runtime to assure we have enough content
    // tp fill the scroller on wide screens.
    if(this.mediaReducedMotion()) return;
    const scrollerInner = this.inner;
    const scrollerContent = Array.from(scrollerInner.children);
    scrollerContent.forEach((item) => {
      const duplicatedItem = item.cloneNode(true);
      duplicatedItem.setAttribute("aria-hidden", true);
      scrollerInner.appendChild(duplicatedItem);
    });
  },
  addAnimation() {
    if (!this.mediaReducedMotion()) {
      $el.dataset.animated = 'true';
    }
  },
  mediaReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
})
